export default "__VITE_ASSET__D8j7Cdkc__"